import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { FormErrorComponent } from '../../form-error/form-error.component';
import { FormControl, ReactiveFormsModule, ValidatorFn } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
import { RichTextInputComponent } from '../../inputs/rich-text-input/rich-text-input.component';
import { HtmlUtils } from '../../../../utils/html-utils';
import { htmlMaxCharacterValidator } from '../../../../validators/html-max-characterl.validator';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'lib-rich-text-form-field',
  imports: [FormErrorComponent, ReactiveFormsModule, RichTextInputComponent, DecimalPipe],
  templateUrl: './rich-text-form-field.component.html',
  styleUrl: './rich-text-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RichTextFormFieldComponent {
  inputFormControl = input.required<FormControl>();
  label = input<string>();
  isSubmitted = input<boolean>(false);
  placeholder = input<string | null | undefined>();
  hintText = input<string | null | undefined>();
  maxCharacters = input<number | null>(null);
  visibleCharacterCount = signal<number>(0);
  inputId: string = uuidv4();

  private maxCharacterValidator: ValidatorFn | null = null;

  formControlEffect = effect(() => {
    this.inputFormControl().valueChanges.subscribe(value => {
      const visibleCharacters = HtmlUtils.countVisibleCharacters(value ?? '');
      this.visibleCharacterCount.set(visibleCharacters);
      if (value !== null && visibleCharacters === 0) {
        // clear form control if visible characters are empty
        this.inputFormControl().setValue(null);
      }
    });
  });

  characterCountEffect = effect(() => {
    const maxCharacters = this.maxCharacters();
    if (maxCharacters !== null) {
      this.maxCharacterValidator = htmlMaxCharacterValidator(maxCharacters);
      this.inputFormControl().addValidators(this.maxCharacterValidator);
    } else if (this.maxCharacterValidator) {
      this.inputFormControl().removeValidators(this.maxCharacterValidator);
    }
  });
}
